package it.neckar.lizergy.lifeCycle

/**
 * Lizergy-internal copy of [it.neckar.lifeCycle.HasLifeCycle].
 */
interface LizergyHasLifeCycle {
  val lifeCycleState: LizergyLifeCycleState

  fun isActive(): Boolean {
    return lifeCycleState.isActive()
  }

  fun isNearEndOfLive(): Boolean {
    return lifeCycleState.isNearEndOfLive()
  }

  fun isNotEndOfLife(): Boolean {
    return lifeCycleState.isNotEndOfLife()
  }

  fun isEndOfLife(): Boolean {
    return lifeCycleState.isEndOfLife()
  }
}

/**
 * Returns a list containing only the active (not [LizergyHasLifeCycle.isEndOfLife]) elements
 */
fun <T : LizergyHasLifeCycle> List<T>.onlyActive(): List<T> {
  return only(LizergyLifeCycleState::isNotEndOfLife)
}

/**
 * Returns only the elements for with the [selector] returns [true].
 * If the [selector] is set to null, all elements are returned.
 */
fun <T : LizergyHasLifeCycle> List<T>.only(selector: ((LizergyLifeCycleState) -> Boolean)?): List<T> {
  if (selector == null) return this

  return this.filter {
    selector(it.lifeCycleState)
  }
}
